import React, { useState } from "react";
import { Slate, useSlate } from "slate-react";
import { Node } from "slate";
import clsx from "clsx";

import { OldContractPreviewTrato } from "./TratoOldFormat";
import { TratoFormat, getEditorInstance } from "./TratoFormat";
import { useConstant } from "../../hooks/useConstant";
import { useEditorActions, useEditorState } from "../../context/editor";

export function TratoDocumentPreview(props) {
  const { document: doc, width, BaseElementComponent, isPremium, isPreview } = props;
  const editor = useConstant(() => getEditorInstance());

  if (doc.isMigrated) {
    const totalElements = doc.elements.length;
    const index = Math.max(Math.ceil(totalElements * 0.4) - 1, 4);
   
    const hasThreePoint = index < totalElements && isPremium;
    const elements = isPreview ? doc.elements?.filter((_,i) => i <= index) : doc.elements;

    // console.log({index, totalElements, elements})

    return (
      <div
        className="p-2 document__preview__new--editor"
        style={{ width, minHeight: 600, overflowY: "auto", maxHeight: "80vh" }}
      >
        <Slate editor={editor} value={elements || []} onChange={() => {}}>
          <TratoFormat
            BaseElementComponent={BaseElementComponent}
            {...props}
            isEditable={false}
            showPlaceholder={false}
            showRemoveSignature={false}
          />
        </Slate>
        { hasThreePoint && <div className="text-center">....</div> }
      </div>
    );
  }

  return <OldContractPreviewTrato contract={doc} {...props} />;
}
